module.exports = __webpack_public_path__ + "img/brand-monzo.a9c858e2.svg";